import styled from 'styled-components';
import { isMobile, isTablet } from 'react-device-detect';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import theme from 'shared/assets/style/theme';

export const UpdateTermsBackgroundImage = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  width: 100%;
  height: 100%;
`;

export const TermsContainer = styled.div`
  height: 85% !important;
`;

export const ErrorText = styled.p`
  text-align: center;
  margin-top: 10px;
  color: red;
`;

export const TermsTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 90%;
  height: 90%;
  margin: 1em auto;
`;

export const TermsUpdateScreenTextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${isTablet ? pwaStyleAdapter(1.5, 'rem') : `calc(14px + (20 - 14) * ((100vw - 800px) / (1600 - 800)))`};
`;

export const TermsImageWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

export const TermsImage = styled.img`
  pointer-events: auto;
  cursor: pointer;
  width: 100%;
  height: auto;
`;

export const TermsFooterWrapper = styled.div`
  justify-content: space-between !important;
  height: 10% !important;
  margin-bottom: ${isMobile && !isTablet ? '1.5rem' : '0px'};
`;

export const TermsUpdateButtonText = styled.p`
  font-weight: 700 !important;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${({ termsState }) => (termsState ? theme.palette.primary[28] : theme.palette.primary[1])};
`;

export const TermsAgreeText = styled.p`
  font-weight: 300;
  font-size: ${isTablet ? pwaStyleAdapter(1.2, 'rem') : isMobile ? pwaStyleAdapter(0.9, 'rem') : '1rem'};
  color: ${theme.palette.common[1]};
  padding-left: 1.5vmin !important;
  cursor: pointer;
`;

